!(function (d) {
  var e,
    n =
      '<svg><symbol id="icon-scan" viewBox="0 0 1024 1024"><path d="M821.845333 85.333333h-128a36.992 36.992 0 0 0-36.864 36.864c0 20.266667 16.64 36.864 36.864 36.864h91.136c20.266667 0 36.864 16.64 36.864 36.864v91.989334c0 20.224 16.64 36.864 36.864 36.864 20.266667 0 36.906667-16.64 36.906667-36.864v-128.853334C895.573333 118.186667 862.72 85.333333 821.845333 85.333333zM122.197333 324.778667c20.266667 0 36.864-16.64 36.864-36.864V195.541333c0-20.266667 16.64-36.864 36.864-36.864H287.146667c20.224 0 36.864-16.64 36.864-36.864A36.736 36.736 0 0 0 286.677333 85.333333H159.146667C118.101333 85.333333 85.333333 118.186667 85.333333 159.061333v128.853334c0 20.224 16.64 36.864 36.864 36.864zM287.488 823.04H195.925333a36.992 36.992 0 0 1-36.864-36.864V694.613333a36.565333 36.565333 0 0 0-36.437333-36.48h-0.853333a36.565333 36.565333 0 0 0-36.437334 36.48v127.573334C85.333333 862.805333 118.186667 896 159.061333 896h128.426667c19.84 0 36.48-16.213333 36.48-36.48a36.565333 36.565333 0 0 0-36.48-36.437333z m571.648-164.906667h-1.237333a36.565333 36.565333 0 0 0-36.437334 36.48v91.562667c0 20.266667-16.64 36.864-36.864 36.864h-91.562666a36.565333 36.565333 0 0 0-36.48 36.437333c0 20.266667 16.213333 36.48 36.48 36.48h128.426666c40.533333 0 73.728-32.853333 73.728-73.728V695.04a35.84 35.84 0 0 0-36.053333-36.864zM122.197333 528.128h736.512c20.266667 0 36.906667-16.597333 36.906667-36.864a36.736 36.736 0 0 0-36.906667-36.864H122.197333a36.992 36.992 0 0 0-36.864 36.864c0 20.266667 16.64 36.864 36.864 36.864z" fill="#1378E0" ></path></symbol></svg>',
    t = (e = document.getElementsByTagName('script'))[e.length - 1].getAttribute('data-injectcss');
  if (t && !d.__iconfont__svg__cssinject__) {
    d.__iconfont__svg__cssinject__ = !0;
    try {
      document.write(
        '<style>.svgfont {display: inline-block;width: 1em;height: 1em;fill: currentColor;vertical-align: -0.1em;font-size:16px;}</style>'
      );
    } catch (e) {
      console && console.log(e);
    }
  }
  !(function (e) {
    if (document.addEventListener)
      if (~['complete', 'loaded', 'interactive'].indexOf(document.readyState)) setTimeout(e, 0);
      else {
        var t = function () {
          document.removeEventListener('DOMContentLoaded', t, !1), e();
        };
        document.addEventListener('DOMContentLoaded', t, !1);
      }
    else
      document.attachEvent &&
        ((o = e),
        (c = d.document),
        (i = !1),
        (a = function () {
          try {
            c.documentElement.doScroll('left');
          } catch (e) {
            return void setTimeout(a, 50);
          }
          n();
        })(),
        (c.onreadystatechange = function () {
          'complete' == c.readyState && ((c.onreadystatechange = null), n());
        }));
    function n() {
      i || ((i = !0), o());
    }
    var o, c, i, a;
  })(function () {
    var e, t;
    ((e = document.createElement('div')).innerHTML = n),
      (n = null),
      (t = e.getElementsByTagName('svg')[0]) &&
        (t.setAttribute('aria-hidden', 'true'),
        (t.style.position = 'absolute'),
        (t.style.width = 0),
        (t.style.height = 0),
        (t.style.overflow = 'hidden'),
        (function (e, t) {
          t.firstChild
            ? (function (e, t) {
                t.parentNode.insertBefore(e, t);
              })(e, t.firstChild)
            : t.appendChild(e);
        })(t, document.body));
  });
})(window);
